import { render } from "./TripTable.vue?vue&type=template&id=002f7144&scoped=true"
import script from "./TripTable.vue?vue&type=script&lang=js"
export * from "./TripTable.vue?vue&type=script&lang=js"

import "./TripTable.vue?vue&type=style&index=0&id=002f7144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002f7144"]])

export default __exports__